export default __webpack_public_path__ + "static/media/95.390623d9.png";